import { action } from '@play-co/replicant';
import createActions from './createActions';
import { stateSchema } from '../../State';
import { duration } from '../../utils/duration';
import { getSharedStateActionsAPI } from './createSharedStatesActions';
import { sendAnalyticsEvents } from 'src/replicant/analytics';

export default createActions({
  updateUserClientSideData: action(
    (state, args: { timezoneOffsetMs: number }, api) => {
      state.timezoneOffsetMs = args.timezoneOffsetMs;
    },
  ),

  setDeleteAccountIntent: action((state, intent: boolean, api) => {
    if (intent) {
      state.deleteAccountIntent = api.date.now();
    } else {
      delete state.deleteAccountIntent;
    }
  }),

  deleteAccount: action((state, _, api) => {
    if (
      state.deleteAccountIntent &&
      !(api.date.now() - state.deleteAccountIntent < duration({ minutes: 1 }))
    ) {
      throw new Error('Unintended account deletion request');
    }

    sendAnalyticsEvents(api, [
      {
        eventType: 'AccountDelete',
        eventProperties: {},
      },
    ]);

    const teamId = state.team.currentTeamId;
    if (teamId) {
      const sharedStatesApi = getSharedStateActionsAPI(api);
      sharedStatesApi.sharedStates.team.postMessage.removeMember(teamId, {
        timestamp: api.date.now(),
        userId: state.id,
      });
    }

    // In with the default state.
    const newState = stateSchema.getDefault()!;
    // copy in critical elements from previous state
    newState.platformStorage = state.platformStorage;
    newState.analytics = state.analytics;
    newState.abTests = state.abTests;
    newState.chatbot = state.chatbot;
    newState.lifetimeValue = state.lifetimeValue;
    newState.actualLTV = state.actualLTV;

    // Out with previous state.
    for (const key in state) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        delete (state as any)[key];
      }
    }

    // assign new state
    Object.assign(state, newState);

    // Nuke metadata
    api.nukeUserMetainfo();
  }),
});
